/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Table, TableBody, TableHead, TableRow, TableContainer, TableCell } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';

import { PerformanaceContent, PerformanceBar, PerformanceBarValues, PerformanceFraction, ShippingArrowDownContainer, ShippingCompanyContainer, ShippingCompanyName, ShippingContainer, ShippingDefaultTableCell, ShippingPerformanaceContent, ShippingPerformanceFraction, ShippingStyledImage, ShippingStyledTableRow, ShippingTable, ShippingTableCellBody, ShippingTableCellHeader, ShippingTableHeader, ShippingTableRow, TableCellBody, TableCellHeader } from './styles';
import ProgressBar from '../../../../../../../../../components/ProgressBar';

const ClientTable = ({
  data,
  headers,
  formatValue,
  showIndex,
  showDropdown,
}) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  function handleDropdownClick(index) {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  } 
  
  if (showDropdown) {
    return (
      <ShippingContainer>
        <ShippingTable>
          <ShippingTableHeader>
            {headers.map((header) => (
              <ShippingTableCellHeader key={header}>{header}</ShippingTableCellHeader>
            ))}
          </ShippingTableHeader>
          <div>
            {data.map((row, index) => (
              <React.Fragment key={row.text}>
                <ShippingTableRow>
                  {showIndex && (
                    <ShippingTableCellBody>{index + 1}</ShippingTableCellBody>
                  )}
                  {/* TODO: Será ocultado até a proxima versão, quando houver mais dados das transportadoras                  
                  {showDropdown && row.shippingCompany ? (
                    <ShippingTableCellBody onClick={() => handleDropdownClick(index)} style={{ cursor: 'pointer' }}>
                      <ShippingArrowDownContainer>
                        {openDropdownIndex === index ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        {row.text}
                      </ShippingArrowDownContainer>
                    </ShippingTableCellBody>
                  ) : ( */}
                    <ShippingTableCellBody>{row.text}</ShippingTableCellBody>
                  {/* )} */}
                  <ShippingTableCellBody>{row.totalQty}</ShippingTableCellBody>
                  <ShippingTableCellBody>
                    <ShippingPerformanaceContent>
                      <CheckCircle fontSize="small" htmlColor="#2E7D32" />
                      {row.onTimeQty}
                    </ShippingPerformanaceContent>
                  </ShippingTableCellBody>
                  <ShippingTableCellBody>
                    <ShippingPerformanaceContent>
                      <Error htmlColor="#F44336" fontSize="small" />
                      {row.lateQty}
                    </ShippingPerformanaceContent>
                  </ShippingTableCellBody>
                  <ShippingTableCellBody>
                    <PerformanceBar>
                      <PerformanceBarValues>
                        <span>
                          {formatValue(row.value)}
                        </span>
                        <span>
                          {formatValue(100 - row.value)}
                        </span>
                      </PerformanceBarValues>
                      <ProgressBar completed={row.value} />
                    </PerformanceBar>
                    <ShippingPerformanceFraction>
                      {row.onTimeQty}/{row.totalQty} NF’s
                    </ShippingPerformanceFraction>
                  </ShippingTableCellBody>
                </ShippingTableRow>

                {openDropdownIndex === index && (
                  row.shippingCompany.map(item => (
                    <ShippingCompanyContainer key={item.name}>
                      <ShippingStyledTableRow>
                        <ShippingCompanyName>
                          <ShippingStyledImage src={item.icon} alt='Icone da transportadora' />
                          <div>{item.name}</div>
                        </ShippingCompanyName>
                        <ShippingDefaultTableCell>{item.totalQty}</ShippingDefaultTableCell>
                        <ShippingDefaultTableCell>
                          <CheckCircle fontSize="small" htmlColor="#2E7D32" />
                          {item.onTimeQty}
                        </ShippingDefaultTableCell>
                        <ShippingDefaultTableCell>
                          <PerformanaceContent>
                            <Error htmlColor="#F44336" fontSize="small" />
                            {item.lateQty}
                          </PerformanaceContent>
                        </ShippingDefaultTableCell>
                        <ShippingTableCellBody>
                          <PerformanceBar>
                            <ProgressBar completed={item.value} />
                            {formatValue(item.value)}
                          </PerformanceBar>
                          <PerformanceFraction>
                            {item.onTimeQty}/{item.totalQty} NF’s
                          </PerformanceFraction>
                        </ShippingTableCellBody>
                      </ShippingStyledTableRow>
                    </ShippingCompanyContainer>
                  ))
                )}
              </React.Fragment>
            ))}
          </div>
        </ShippingTable>
      </ShippingContainer>
    )
  }

  return (
    <TableContainer sx={{ maxHeight: 440 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCellHeader key={header}>{header}</TableCellHeader>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={row.text}
            >
              {showIndex && (
                <TableCellBody component="th" scope="row">
                  {index + 1}
                </TableCellBody>
              )}
              <TableCellBody>{row.text}</TableCellBody>
              <TableCellBody>
                {row.totalQty}
              </TableCellBody>
              {/* <TableCellBody>
                <PerformanaceContent>
                  <CheckCircle fontSize="small" htmlColor="#1B5E20" /> 
                  {formatValue(row.value)}
                </PerformanaceContent>
              </TableCellBody> */}
              <TableCellBody>
                <PerformanaceContent>
                  <CheckCircle fontSize="small" htmlColor="#2E7D32" />
                  {row.onTimeQty}
                </PerformanaceContent>
              </TableCellBody>
              <TableCellBody>
                <PerformanaceContent>
                  <Error htmlColor="#F44336" fontSize="small" />
                  {row.lateQty}
                </PerformanaceContent>
              </TableCellBody>
              <TableCellBody>
                <PerformanceBar>
                  <ProgressBar completed={row.value} />
                  {formatValue(row.value)}
                </PerformanceBar>
                <PerformanceFraction>
                  {row.onTimeQty}/{row.totalQty} NF’s
                </PerformanceFraction>
              </TableCellBody>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ClientTable;
